// src/utils/costiUtils.js - Calcolo costi delle righe dei rapportini

/**
 * Converte in numero un valore di ore/importi salvato in un rapportino.
 *
 * Nei rapportini alcuni valori sono salvati come testo, anche codici del
 * cartellino come "CIG" o "C": `parseFloat(valore || 0)` restituisce NaN e
 * una sola riga rende NaN l'intera somma. I valori non numerici valgono 0.
 */
export const toNumber = (value) => parseFloat(value) || 0;

/**
 * Costo di una riga di personale di un rapportino.
 *
 * Le righe create dalle timbrature kiosk (rapportiniAutoService) per lungo tempo
 * hanno salvato il costo solo in `costoTotale`, senza `totale`: sommare solo
 * `totale` le azzerava. Se `totale` manca si ricalcola ore × costo orario
 * salvato nel rapportino (tariffa storica del giorno, non quella attuale).
 */
export const getCostoPersona = (persona) => {
  const totale = parseFloat(persona?.totale);
  if (!Number.isNaN(totale)) return totale;
  return toNumber(persona?.oreLavorate) * toNumber(persona?.costoOrario);
};
